import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Share2, Copy, Palette, Download, Loader2 } from 'lucide-react';
import { API, errText } from '../../api';

export default function AfterPurchaseTools({ req, onUpdated }) {
  const [kitBusy, setKitBusy] = useState(false);
  const hasLogo = !!(req.profile_full?.files?.length);

  const toggleShare = async () => {
    try {
      const updated = await API.setShare(req.code, !req.share_enabled);
      onUpdated(updated);
      toast.success(updated.share_enabled ? 'Your song page is live.' : 'Sharing turned off.');
    } catch (e) { toast.error(errText(e, 'Could not update sharing.')); }
  };
  const copyShare = async () => {
    try { await navigator.clipboard.writeText(`${window.location.origin}/song/${req.code}`); toast.success('Link copied.'); }
    catch (e) { toast.error('Could not copy.'); }
  };
  const getKit = async () => {
    setKitBusy(true);
    try { await API.downloadLogoKit(req.code, req.business); toast.success('Logo kit downloaded.'); }
    catch (e) { toast.error('Could not build your logo kit.'); }
    finally { setKitBusy(false); }
  };

  return (
    <div className="mt-7 grid sm:grid-cols-2 gap-4 pt-6 border-t hairline" data-testid="after-purchase-tools">
      <div className="rounded-2xl border hairline p-5">
        <p className="flex items-center gap-2 text-sm text-cream"><Share2 size={15} className="text-gold" /> Share your song</p>
        <p className="text-xs text-cream/50 mt-1">A public page with your logo and player. Post it anywhere.</p>
        <div className="mt-4 flex items-center gap-2">
          <button onClick={toggleShare} data-testid="share-toggle" role="switch" aria-checked={!!req.share_enabled} className={`relative w-11 h-6 rounded-full transition-colors ${req.share_enabled ? 'bg-gold' : 'bg-white/10'}`}><span className={`absolute top-0.5 w-5 h-5 rounded-full bg-ink transition-transform ${req.share_enabled ? 'left-[22px]' : 'left-0.5'}`} /></button>
          <span className="text-xs text-cream/70">{req.share_enabled ? 'Sharing on' : 'Sharing off'}</span>
        </div>
        {req.share_enabled && (
          <div className="mt-3 flex items-center gap-2">
            <Link to={`/song/${req.code}`} data-testid="share-page-link" className="text-xs text-gold hover:underline truncate">/song/{req.code}</Link>
            <button onClick={copyShare} data-testid="share-copy" className="grid place-items-center w-7 h-7 rounded-full border hairline text-cream/60 hover:text-gold"><Copy size={12} /></button>
          </div>
        )}
      </div>
      <div className="rounded-2xl border hairline p-5">
        <p className="flex items-center gap-2 text-sm text-cream"><Palette size={15} className="text-gold" /> Social logo kit</p>
        <p className="text-xs text-cream/50 mt-1">{hasLogo ? 'Circle-safe profile pictures for every platform plus song covers, built from your logo.' : 'Upload a logo with your next request and we\u2019ll build your kit.'}</p>
        <button onClick={getKit} disabled={!hasLogo || kitBusy} data-testid="logo-kit-btn" className="mt-4 btn-ghost rounded-full px-4 py-2 text-xs flex items-center gap-2 disabled:opacity-50">{kitBusy ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />} Download kit (.zip)</button>
      </div>
    </div>
  );
}
